export default __webpack_public_path__ + "static/media/583.6c1211be.jpg";